<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-caret-left`]" width="1em" height="1em" v-bind="$attrs"><path d="M30.311 6.604C30.948 6 32 6.451 32 7.33v33.342c0 .878-1.052 1.33-1.689.725L12.763 24.725a1 1 0 010-1.45l17.548-16.67z"/></svg>
</template>
<script>

export default {
  name: 'IconCaretLeft',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
